import { createContext, useContext, useState, type ReactNode } from "react";

interface SidebarState {
  collapsed: boolean;
  hidden: boolean;
  setCollapsed: (v: boolean) => void;
  setHidden: (v: boolean) => void;
}

const SidebarContext = createContext<SidebarState>({
  collapsed: false,
  hidden: false,
  setCollapsed: () => {},
  setHidden: () => {},
});

export function SidebarProvider({ children }: { children: ReactNode }) {
  const [collapsed, setCollapsedState] = useState(() => {
    try { return localStorage.getItem("sidebarCollapsed") === "true"; } catch { return false; }
  });
  const [hidden, setHidden] = useState(false);

  const setCollapsed = (v: boolean) => {
    setCollapsedState(v);
    try { localStorage.setItem("sidebarCollapsed", String(v)); } catch {}
  };

  return (
    <SidebarContext.Provider value={{ collapsed, hidden, setCollapsed, setHidden }}>
      {children}
    </SidebarContext.Provider>
  );
}

export const useSidebar = () => useContext(SidebarContext);
